module.exports = __webpack_public_path__ + "img/logo1.5a0bafac.png";